import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const Field = ({ label, field, type = "text", value, onChange, options, placeholder, span }) => {
  const id = `field-${field}`;
  const set = (v) => onChange(field, v);
  return (
    <div className={span === 2 ? "sm:col-span-2" : ""}>
      <Label htmlFor={id} className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </Label>
      <div className="mt-1.5">
        {type === "select" ? (
          <Select value={value || ""} onValueChange={set}>
            <SelectTrigger id={id} data-testid={id} className="h-9">
              <SelectValue placeholder={placeholder || "Select"} />
            </SelectTrigger>
            <SelectContent>
              {(options || []).map((o) => (
                <SelectItem key={o} value={o} data-testid={`${id}-opt-${o}`}>{o}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : type === "textarea" ? (
          <Textarea id={id} data-testid={id} value={value || ""} placeholder={placeholder}
            onChange={(e) => set(e.target.value)} className="min-h-[72px]" />
        ) : type === "date" ? (
          <Input id={id} data-testid={id} type="date"
            value={value ? String(value).slice(0, 10) : ""}
            onChange={(e) => set(e.target.value ? `${e.target.value}T00:00:00` : "")} className="h-9" />
        ) : type === "datetime" ? (
          <Input id={id} data-testid={id} type="datetime-local"
            value={value ? String(value).slice(0, 16) : ""}
            onChange={(e) => set(e.target.value ? `${e.target.value}:00` : "")} className="h-9" />
        ) : (
          <Input id={id} data-testid={id} type={type} value={value ?? ""} placeholder={placeholder}
            onChange={(e) => set(type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
            className="h-9" />
        )}
      </div>
    </div>
  );
};

export const Section = ({ title, children }) => (
  <div className="space-y-3">
    <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-[#0055FF] border-b border-border/60 pb-1.5">
      {title}
    </h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">{children}</div>
  </div>
);

export const RefSelect = ({ label, value, options, onSelect, placeholder, testid, span }) => (
  <div className={span === 2 ? "sm:col-span-2" : ""}>
    <Label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</Label>
    <div className="mt-1.5">
      <Select value={value || ""} onValueChange={onSelect}>
        <SelectTrigger data-testid={testid} className="h-9"><SelectValue placeholder={placeholder || "Select"} /></SelectTrigger>
        <SelectContent>
          {(options || []).map((o) => (
            <SelectItem key={o.id} value={o.id} data-testid={`${testid}-opt-${o.id}`}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  </div>
);
